import React from 'react';
import Modal from 'react-modal';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '0px !important',
        background: 'none !important'
    }
};

class MessagePopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = { modalIsOpen: true, popupTitle: ((typeof this.props.popupTitle !=='undefined' && this.props.popupTitle !=='' && this.props.popupTitle != null) ? this.props.popupTitle:'Message'), messageContent: this.props.messageContent};

        this.handleAction = this.handleAction.bind(this);	
        this.closeModal = this.closeModal.bind(this);
    };

    handleAction(event, name) {
        this.props.popupActionHandler(name);
	}
    closeModal(event) {
        this.setState({ modalIsOpen: false });
        if(typeof this.props.popupActionHandler !== 'undefined'){
            this.props.popupActionHandler('close');
        }
        
    }

    componentWillReceiveProps(nextProps) {
        // this.setState({ modalIsOpen: nextProps.modalIsOpen, popupTitle: nextProps.popupTitle });
    }

    render() {
        let _this=this;
        return (
            <Modal
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                contentLabel="Example Modal"
                style={customStyles} ariaHideApp={false} >
                <div className="card card-sub popup-body">
                    <div className="card card-body card-body-body-content card-sub popup-body">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header modal-heading-popup">
                                    <button type="button" className="btn-close close popup-close-btn" onClick={this.closeModal} aria-label="Close"><span className="float-end glyphicon glyphicon-remove-circle" onClick={this.closeModal} aria-hidden="true"></span></button>
                                    <span className="modal-title" id="popupModalLabel">{this.state.popupTitle}</span>
                                </div>
                                <div className="modal-body modal-body-popup pre-scrollable" id="popupModal-body">
                                    {this.state.messageContent}

                                    {this.props.popupAction != null && (typeof this.props.popupAction !== 'undefined')?
                                    (<div classNamw="card card-body print-area card-button-group">
                                        <div className="btn-group float-end">
                                            {this.props.popupAction.map(function(name, index){
                                                return ((name==='Yes' || name==='Ok' || name==='Login')?(<a key={ index } type="button" className="btn btn-sm btn-primary btn-submit" onClick={(e) => { _this.handleAction(e,name) }} >{name}</a>):(
                                                    <a key={ index } type="button" className="btn btn-sm btn-primary btn-cancel" onClick={(e) => { _this.handleAction(e,name) }} >{name}</a>)
                                                )
                                            })}
                                        </div>
                                    </div>):null
                                    }
                                </div>
                                
                                <div className="modal-footer">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

}

export default MessagePopup;